var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_CHECK_INFO, SET_MERCHANT_INFO, SET_PROCESSED_PAYMENT_INFO, SET_CREDIT_CARD_REQUEST_STATUS, } from "actions/mobile_pay";
import { RequestStatus } from "types/requests";
var initialState = {
    checkInfoRequest: { type: RequestStatus.NOT_STARTED },
    merchantInfoRequest: { type: RequestStatus.NOT_STARTED },
    processedPaymentInfoRequest: { type: RequestStatus.NOT_STARTED },
    creditCardRequestStatus: RequestStatus.NOT_STARTED,
};
function mobilePayReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_CHECK_INFO: {
            return __assign(__assign({}, state), { checkInfoRequest: action.checkInfo });
        }
        case SET_MERCHANT_INFO: {
            return __assign(__assign({}, state), { merchantInfoRequest: action.merchantInfo });
        }
        case SET_PROCESSED_PAYMENT_INFO: {
            return __assign(__assign({}, state), { processedPaymentInfoRequest: action.processedPaymentInfo });
        }
        case SET_CREDIT_CARD_REQUEST_STATUS: {
            return __assign(__assign({}, state), { creditCardRequestStatus: action.status });
        }
        default:
            return state;
    }
}
export default mobilePayReducer;
